import { useEffect } from 'react';

export const useAddCanonicalLink = (canonicalUrl?: string) => {
  useEffect(() => {
    if (!canonicalUrl) {
      return;
    }

    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.insertBefore(canonicalLink, document.head.firstChild);
    }
    
    canonicalLink.setAttribute('href', canonicalUrl);
  }, [canonicalUrl]);
};
import { useEffect } from 'react';

export const useAddCanonicalLink = (canonicalUrl?: string) => {
  useEffect(() => {
    if (!canonicalUrl) {
      return;
    }

    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.insertBefore(canonicalLink, document.head.firstChild);
    }
    
    canonicalLink.setAttribute('href', canonicalUrl);
  }, [canonicalUrl]);
};
